import { resolveApiUrl } from "@/lib/api-url";

/** Dev/test helper: mark a pending donation failed via the Razorpay webhook shim. */
export async function simulatePaymentFailed(orderId: string): Promise<void> {
  const res = await fetch(resolveApiUrl("/api/webhooks/razorpay"), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Razorpay-Signature": "mock_signature",
    },
    body: JSON.stringify({
      event: "payment.failed",
      payload: {
        payment: {
          entity: {
            order_id: orderId,
          },
        },
      },
    }),
  });

  if (!res.ok) {
    const text = await res.text().catch(() => "Webhook simulation failed");
    throw new Error(text || `Webhook simulation failed (${res.status})`);
  }
}
